import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  "aria-live": "assertive",
  class: "inset-0 flex items-end px-4 py-6 sm:p-6 sm:items-start"
}
const _hoisted_2 = { class: "w-full flex flex-col items-center space-y-4 sm:items-end" }
const _hoisted_3 = { class: "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = {
  key: 0,
  class: "shrink-0"
}
const _hoisted_7 = {
  key: 1,
  class: "shrink-0"
}
const _hoisted_8 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "ml-4 shrink-0 flex" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_notifications, {
      position: "bottom right",
      width: "100%",
      "dangerously-set-inner-html": true
    }, {
      body: _withCtx((props) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_Transition, {
              "enter-active-class": "ease-out duration-300 transition",
              "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
              "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (props.item.type === 'success')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_CheckCircleIcon, {
                              class: "h-6 w-6 text-green-400",
                              "aria-hidden": "true"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_XCircleIcon, {
                              class: "h-6 w-6 text-red-700",
                              "aria-hidden": "true"
                            })
                          ])),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", {
                          class: "text-sm font-medium text-gray-900",
                          "data-name": "notificationText",
                          innerHTML: props.item.text
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: props.close,
                          class: "bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        }, [
                          _hoisted_12,
                          _createVNode(_component_XIcon, {
                            class: "h-5 w-5",
                            "aria-hidden": "true"
                          })
                        ], 8, _hoisted_11)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}